<mat-card appearance="outlined" class="person-card">
  <mat-card-header class="person-header">
    <div mat-card-avatar><mat-icon>person</mat-icon></div>
    <mat-card-title class="person-title">{{ userName }}</mat-card-title>
  </mat-card-header>
</mat-card>
<mat-nav-list>
  <a [routerLink]="cmdSettings.route" mat-list-item (click)="openLink($event)">
    <span mat-line
      ><mat-icon class="link-icon">{{ cmdSettings.icon }}</mat-icon
      >{{ cmdSettings.text }}</span
      >
    </a>

    @if (hasDefaultHelp()) {
      <div>
        <a [routerLink]="cmdDefaultHelp.route" mat-list-item (click)="openLink($event)">
          <span mat-line
            ><mat-icon class="link-icon">{{ cmdDefaultHelp.icon }}</mat-icon
            >{{ cmdDefaultHelp.text }}</span
            >
          </a>
          <!--
          <a mat-list-item (click)="openHelp(cmdDefaultHelp)">
            <span mat-line><mat-icon class="link-icon">{{cmdDefaultHelp.icon}}</mat-icon>{{cmdDefaultHelp.text}}</span>
          </a>
        --></div>
      }

      @if (hasCustomHelp()) {
        <div>
          <a mat-list-item (click)="openHelp(cmdCustomHelp)">
            <span mat-line
              ><mat-icon class="link-icon">{{ cmdCustomHelp.icon }}</mat-icon
              >{{ cmdCustomHelp.text }}</span
              >
            </a>
          </div>
        }

        <a [routerLink]="cmdSignOff.route" mat-list-item (click)="openLink($event)">
          <span mat-line
            ><mat-icon class="link-icon">{{ cmdSignOff.icon }}</mat-icon
            >{{ cmdSignOff.text }}</span
            >
          </a>
        </mat-nav-list>
